import "./Footer.css";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="container footer__inner">
        <a className="footer__top" href="#top" onClick={(e) => {
          e.preventDefault();
          document.querySelector("#top")?.scrollIntoView({ behavior: "smooth" });
        }}>
          Back to top
        </a>

        <div className="footer__links">
          <a href="https://www.linkedin.com/in/zabreissouf/" target="_blank" rel="noreferrer">LinkedIn</a>
          <a href="https://github.com/zabroski" target="_blank" rel="noreferrer">GitHub</a>
        </div>

        <div className="footer__copy">© {year} Issouf Zabre</div>
      </div>
    </footer>
  );
}
